export default async function ({ route, app }) {
  const routePath = route.path || '';
  const key = routePath.split('/').pop().split('?')[0];
  app.$layoutKey = key;
}
